module.exports = __webpack_public_path__ + "img/arrow_down.b4719384.svg";